import './App.css';

const projects = [
  {
    title: "Mafteiach",
    webLink: "https://www.mafteiach.app/",
    installLink: "http://onelink.to/mftch-install",
    playStoreLink: "https://play.google.com/store/apps/details?id=app.mafteiach.app",
    AppStoreLink: "https://apps.apple.com/us/app/mafteiach/id1455806077",
    tools: ["Ruby on Rails", "Tachyons"],
    image: '/media/projects/mafteiach-01.png'
  },
  {
    title: "Daily Rambam",
    webLink: "https://www.dailyrambam.org/",
    tools: ["Ruby on Rails", "Bootstrap 4"],
    image: '/media/projects/daily-rambam-01.png'
  },
  {
    title: "Press it clicker game",
    webLink: "/press-it",
    tools: ["p5.js"],
    image: '/media/projects/press-it-01.png'
  },
  {
    title: "Chess game",
    webLink: "https://ae-chess.netlify.app/",
    githubLink: "https://github.com/arye-eidelman/chess",
    tools: ["React 17", "Tailwind 3", "Netlify"],
    image: '/media/projects/chess-01.png'
  },
  {
    title: "Snake game",
    webLink: "https://ae-snake.netlify.app/",
    githubLink: "https://github.com/arye-eidelman/snake",
    tools: ["React 17", "Tailwind 2", "Netlify"],
    image: '/media/projects/snake-01.png'
  },
]

function WrapBreakpoint() { return <span className='inline-block'></span> }

function App() {
  return (
    <div className="App bg-neutral-100 min-h-screen dark:bg-neutral-800 dark:text-neutral-200">
      <header className='bg-white dark:bg-black shadow-md'>

        <div className='container max-w-md md:max-w-4xl lg:max-w-6xl mx-auto center'>
          <nav className='mx-3'>
            <a className='menu-item' href="https://www.linkedin.com/in/arye-eidelman/">LinkedIn</a>
            <a className='menu-item' href="https://github.com/arye-eidelman">Github</a>
            <a className='menu-item' href="https://stackoverflow.com/users/3458162/arye-eidelman">StackOverflow</a>
          </nav>
        </div>
      </header>

      <div className='py-8 mx-auto max-w-md md:max-w-4xl lg:max-w-6xl'>
        <section className='m-3 shadow-md rounded-lg bg-white dark:bg-black divide-y-2 divide-neutral-200 dark:divide-neutral-800'>
          <div className='p-3 font-code'>
            <h1 className='font-bold text-2xl'>Arye Eidelman</h1>
            <a href="mailto:aryedoveidelman@gmail.com" className='a-fixed-padding'>
              aryedoveidelman<WrapBreakpoint />@gmail.com
            </a>
          </div>
          <p className='p-3'>
            Software Developer
          </p>
        </section>

        <section className='m-3 shadow-md rounded-lg bg-white dark:bg-black'>
          <div className='p-3 font-code'>
            <h2 className='font-bold text-2xl'>Projects</h2>
          </div>
          <div className='p-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
            {projects.map(({ title, webLink, installLink, githubLink, tools, image }, i) => (
              <article key={i} className='border border-neutral-200 dark:border-neutral-800 rounded-lg overflow-hidden hover:shadow-lg transition-shadow'>
                <div className='aspect-video bg-neutral-200 dark:bg-neutral-700 flex items-center justify-center'>
                  {image ? (
                    <img src={image} alt={title} className='w-full h-full object-cover' />
                  ) : (
                    <div className='text-neutral-400 dark:text-neutral-500 text-sm'>Project Image</div>
                  )}
                </div>
                <div className='p-3'>
                  <h3 className='pb-2 text-lg font-semibold'>{title}</h3>
                  <p className='space-x-0 mb-2'>
                    {webLink && <><a href={webLink} className="a-fixed-padding">Web</a>{' '}</>}
                    {installLink && <><a href={installLink} className="a-fixed-padding">Install</a>{' '}</>}
                    {githubLink && <><a href={githubLink} className="a-fixed-padding">GitHub</a>{' '}</>}
                  </p>
                  <p className='space-x-2 flex flex-wrap gap-1'>
                    {tools.map(tool =>
                      <span
                        key={tool}
                        className='inline-block rounded-full px-2 py-0.5 text-xs font-semibold bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-400'
                      >
                        {tool}
                      </span>)}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default App;
